import React, { useContext, useRef, useState } from "react";
import styles from './FormPairs.module.scss'
import Button from "../../../../../../../../../../../components/ripple/Button";
import Input from "../../../../../../../../../../../components/Input";
import { FoldingContentContext } from "../../../../../../../../../../../components/folding/FoldingContent";

// const pairItem = {
//     name: 'input name',
//     placeholder: 'input placeholder',
//     type: 'html type',
//     internal: 'locked for custom app',
//     initialValue: 'value when field is empty',
// }

function FormPairs({
                       app, update, messages,
                       pair, prop,
                   }) {

    const foldingContentContext = useContext(FoldingContentContext);

    const getPairValues = () => {
        let values = {};
        pair.map(p => values[p.name] = p.initialValue || '');
        return values
    }

    const [edit, setEdit] = useState({...{index: undefined}, ...getPairValues()});

    const focus = useRef(undefined);

    const onAdd = (pairIndex, fieldIndex) => {
        foldingContentContext?.recalculateHeight();
        update({[prop]: [...(app[prop] || []), ...[getPairValues()]]});
        setTimeout(
            () => {
                document.getElementById(`${app._id}-${prop}-pair-${pairIndex}-field-${fieldIndex}`)?.focus()
            },
            1
        );
    }

    const _setEdit = (item, index) => {
        const valid = typeof index === 'number';
        let _edit = {index: valid ? index : undefined};
        pair.map(p => _edit[p.name] = valid ? item[p.name] : p.initialValue || '');
        setEdit(_edit)
    }

    const onDelete = index => {
        update({[prop]: [...app[prop].slice(0, index), ...app[prop].slice(index + 1)]});
        _setEdit(null, null);
    }

    const onChange = (e, index) => {
        const result = app[prop] || [];
        const item = {
            ...result[index],
            ...{[e.target.name]: e.target.value}
        };
        setEdit({...edit, ...{[e.target.name]: e.target.value}});
        update({[prop]: [...result.slice(0, index), ...[item], ...result.slice(index + 1)]});
    }

    const isFilled = index => {
        const item = app[prop]?.[index];
        return !!Object.keys(item || {}).some(key => !!item[key] || !isNaN(parseFloat(item[key])));
    }

    const onBlur = index => {
        // remove focus ref to clear previous focuses
        focus.current = undefined;
        // clear current edition
        _setEdit(null, null);
        // if field should be deleted wait a tick in case user focused another field from this pair
        if (!isFilled(index)) {
            setTimeout(() => {
                // if no new focus index appeared instantly by click or tab, remove excessive field
                if (focus.current !== index) onDelete(index);
            }, 1)
        }
    }

    const renderPairs = (item, index, isNew) => {
        return pair.map((field, fieldIndex) => {
            const isEdit = typeof edit.index === 'number' && index === edit.index;
            return (
                <Input
                    id={`${app._id}-${prop}-pair-${index}-field-${fieldIndex}`}
                    className={styles.form__inputs__input}
                    type={field.type}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={isEdit ? edit[field.name] || '' : item[field.name]}
                    onChange={e => onChange(e, index)}
                    onFocus={() => {
                        focus.current = index;
                        if (!isNew) {
                            _setEdit(item, index);
                        } else {
                            onAdd(index, fieldIndex)
                        }
                    }}
                    onBlur={() => onBlur(index)}
                    disabled={!!field.internal && app.custom}
                    isValid={messages?.find(m => m.part === `app-${app._id}-${prop}-${index}-${field.name}`) ? false : undefined}
                    error={messages?.find(m => m.part === `app-${app._id}-${prop}-${index}-${field.name}`)?.message}
                    key={index + field.name}
                />
            )
        })
    }

    const renderList = (item, index, isNew) => {
        return (
            <div className={styles.form} key={index + prop}>
                <div className={styles.form__inputs}>
                    {renderPairs(item, index, isNew)}
                </div>
                <Button
                    className={styles.form__button}
                    displayType='text'
                    icon='fas fa-times'
                    visuals={{
                        colorBasicNotContained: ['var(--colorAccentSoft)'],
                        colorBasic: ['var(--colorAccentLight)'],
                        borderRadius: '50%',
                    }}
                    disabled={isNew || !isFilled(index)}
                    onClick={() => onDelete(index)}
                />
            </div>
        )
    }

    const newIsAllowed = (
        !app[prop]?.length || isFilled(app[prop]?.length - 1)
    )

    return (
        <>
            <div className={styles.container}>
                <div className={styles.list}>
                    {!!app?.[prop]?.length && app[prop].map((item, index) => renderList(item, index))}
                    {newIsAllowed && renderList(getPairValues(), app[prop]?.length || 0, true)}
                </div>
            </div>
        </>
    )
}

export default FormPairs